// extracted by mini-css-extract-plugin
export default {"globalSearch":"styles_globalSearch__LBQAB","searchResults":"styles_searchResults__hMRGI","loadingContainer":"styles_loadingContainer__p+qXa","resultItem":"styles_resultItem__luyrr"};